import type { LeadFlow, FlowStepInput } from '@/data'
import { toBool } from '@/utils/toBool'
import api from '..'

function normalizeInput(input: FlowStepInput): FlowStepInput {
  return {
    ...input,
    required: toBool(input.required),
    placeholder: input.placeholder ?? null,
  }
}

export async function getFlow(slug: string): Promise<LeadFlow | null> {
  const res = await api.get(`/flows/${slug}`)
  const flow: LeadFlow | null = res.data.data
  if (!flow) return null
  return {
    ...flow,
    steps: flow.steps.map((step) => ({
      ...step,
      inputs: step.inputs.map(normalizeInput),
    })),
  }
}
